const INSTAGRAM_EMBED_SCRIPT_SRC = "https://www.instagram.com/embed.js"
const INSTAGRAM_SCRIPT_WAIT_TIMEOUT_MS = 5000

let instagramScriptPromise

function forceInstagramProcess() {
  if (!window.instgrm?.Embeds?.process) return

  window.instgrm.Embeds.process()

  // 初回で反映されないケース向けに再実行
  setTimeout(() => {
    if (window.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process()
    }
  }, 300)
}

function loadInstagramScript() {
  if (window.instgrm?.Embeds?.process) {
    return Promise.resolve()
  }

  if (instagramScriptPromise) {
    return instagramScriptPromise
  }

  instagramScriptPromise = new Promise((resolve, reject) => {
    let timeoutId

    const resolveOnce = () => {
      if (timeoutId) clearTimeout(timeoutId)
      resolve()
    }

    const rejectOnce = (error) => {
      if (timeoutId) clearTimeout(timeoutId)
      reject(error)
    }

    const existingScript = document.querySelector(
      `script[src="${INSTAGRAM_EMBED_SCRIPT_SRC}"]`
    )

    if (existingScript) {
      if (window.instgrm?.Embeds?.process) {
        resolveOnce()
        return
      }

      existingScript.addEventListener("load", () => resolveOnce(), { once: true })
      existingScript.addEventListener("error", () =>
        rejectOnce(new Error("Failed to load Instagram embed.js")),
        { once: true }
      )

      timeoutId = setTimeout(() => {
        rejectOnce(new Error("Timed out waiting for Instagram embed.js"))
      }, INSTAGRAM_SCRIPT_WAIT_TIMEOUT_MS)
      return
    }

    const script = document.createElement("script")
    script.src = INSTAGRAM_EMBED_SCRIPT_SRC
    script.async = true
    script.onload = () => resolveOnce()
    script.onerror = () =>
      rejectOnce(new Error("Failed to load Instagram embed.js"))

    document.body.appendChild(script)

    timeoutId = setTimeout(() => {
      rejectOnce(new Error("Timed out waiting for Instagram embed.js"))
    }, INSTAGRAM_SCRIPT_WAIT_TIMEOUT_MS)
  })

  instagramScriptPromise = instagramScriptPromise.catch((error) => {
    instagramScriptPromise = undefined
    throw error
  })

  return instagramScriptPromise
}

function processInstagramEmbeds() {
  const embeds = document.querySelectorAll(".instagram-media")
  if (!embeds.length) return

  loadInstagramScript()
    .then(() => {
      forceInstagramProcess()
    })
    .catch(() => {})
}

document.addEventListener("DOMContentLoaded", () => {
  processInstagramEmbeds()
})
document.addEventListener("turbo:load", processInstagramEmbeds)
document.addEventListener("turbo:render", processInstagramEmbeds)
window.addEventListener("pageshow", processInstagramEmbeds)
